import { SVGAttributes } from 'react'

export const ConferenceRoom = (props: SVGAttributes<SVGElement>) => (
  <svg {...props} viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4999 32.6666H20.2333C20.3805 32.6666 20.4999 32.5472 20.4999 32.3999V29.5999C20.4999 29.4526 20.3805 29.3333 20.2333 29.3333H13.4333C13.286 29.3333 13.1666 29.2139 13.1666 29.0666V26.6666V20.0999C13.1666 19.9526 13.0472 19.8333 12.8999 19.8333H10.0999C9.95264 19.8333 9.83325 19.9526 9.83325 20.0999V32.3999C9.83325 32.5472 9.95264 32.6666 10.0999 32.6666H14.4999ZM14.4999 32.6666V37.3333M14.4999 37.3333H17.8333M14.4999 37.3333H11.1666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M42.5001 32.6666H36.7667C36.6195 32.6666 36.5001 32.5472 36.5001 32.3999V29.5999C36.5001 29.4526 36.6195 29.3333 36.7667 29.3333H43.5667C43.714 29.3333 43.8334 29.2139 43.8334 29.0666V26.6666V20.0999C43.8334 19.9526 43.9528 19.8333 44.1001 19.8333H46.9001C47.0474 19.8333 47.1667 19.9526 47.1667 20.0999V32.3999C47.1667 32.5472 47.0474 32.6666 46.9001 32.6666H42.5001ZM42.5001 32.6666V37.3333M42.5001 37.3333H39.1667M42.5001 37.3333H45.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.8333 23.3333L25.1666 23.3333M37.1666 23.3333L31.8333 23.3333M25.1666 23.3333L31.8333 23.3333M25.1666 23.3333L25.1666 33.3333M25.1666 37.3333L25.1666 33.3333M31.8333 23.3333L31.8333 33.3333M31.8333 37.3333L31.8333 33.3333M25.1666 33.3333L31.8333 33.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
